import { inject } from '@angular/core';

import { injectMutation } from '@tanstack/angular-query-experimental';

import { firstValueFrom } from 'rxjs';

import { ExportTemplate } from 'src/app/core/models/core.models';
import {
  ExportTemplateApiService,
  ExportTemplateFormValue,
} from '../services/export-template-api.service';

export interface SaveExportTemplateInput {
  /** Set → edit_template (update); null/absent → add_template (create). */
  id?: string | number | null;
  template: ExportTemplateFormValue;
}

/**
 * Create-or-update an export template - `id` branches POST
 * /export_template/add_template vs /export_template/edit_template.
 *
 * Resolves with the saved template in both branches (edit unwraps
 * `export_template`) so the host grid can refresh its row from the response.
 */
export function injectSaveExportTemplateMutation() {
  const exportTemplateApi = inject(ExportTemplateApiService);

  return injectMutation(() => ({
    mutationFn: ({
      id,
      template,
    }: SaveExportTemplateInput): Promise<ExportTemplate> =>
      id
        ? firstValueFrom(exportTemplateApi.editTemplate(id, template)).then(
            (response) => response.export_template,
          )
        : firstValueFrom(exportTemplateApi.addTemplate(template)),
  }));
}
